import { computed, inject, ref } from 'vue';

import { useI18n } from 'vue-i18n';

export const props = {
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: null,
  },
  memo: {
    type: String,
    default: null,
  },
};

export const emits = ['onStepValidate'];

export const useSection = (_id: string) => {
  const id = ref(_id);

  const { t } = useI18n();

  const sections = inject('sections', ref<string[]>([]));

  const preTitle = computed(() =>
    t('StrapFinderConfigurator.section.preTitle', {
      current: sections.value.indexOf(_id) + 1,
      total: sections.value.length,
    }),
  );

  const nextSectionId = computed(() => sections.value[sections.value.indexOf(_id) + 1]);

  return {
    id,
    preTitle,
    nextSectionId,
  };
};
